/**
 * Template method to create a reducer based a templateName.
 */
export default function(templateName, sort) {
    const initialState = {
        loading: false,
        data: [],
    };
    const reducer = (state = initialState, action) => {
        switch (action.type) {
            case `${templateName}_PENDING`: {
                return {
                    ...state,
                    loading: true,
                };
            }
            case `${templateName}_REJECTED`: {
                return {
                    ...state,
                    loading: false,
                };
            }
            case `${templateName}_LIST_FULFILLED`: {
                const data = action.payload;
                if (sort) {
                    data.sort(sort);
                }
                return {
                    ...state,
                    loading: false,
                    data,
                };
            }
            case `${templateName}_CREATE_FULFILLED`: {
                const newRow = action.payload;
                // add the new item to the array
                const data = [...state.data, newRow];
                if (sort) {
                    data.sort(sort);
                }
                return {
                    ...state,
                    loading: false,
                    data,
                };
            }
            case `${templateName}_UPDATE_FULFILLED`: {
                const updatedRow = action.payload;
                // update the row with the same ID with new data
                const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
                if (sort) {
                    data.sort(sort);
                }
                return {
                    ...state,
                    loading: false,
                    data,
                };
            }
            case `${templateName}_REMOVE_FULFILLED`: {
                const id = action.payload;
                return {
                    ...state,
                    loading: false,
                    data: state.data.filter(row => row.id !== id),
                };
            }
            default:
                return state;
        }
    };
    return reducer;
}
